<template>
    <article class="cz2__checkout-item__packaging">
        <div
            class="cz2__checkout-item__packaging-image"
            :style="{
                backgroundImage: `url(${imageLink})`,
            }"
        />

        <div class="cz2__checkout-item__packaging-content">
            <div class="cz2__checkout-item__packaging-content__text">
                <h2 class="cz2__checkout-item__name">
                    {{seasonalBox.header}}
                </h2>

                <p class="cz2__checkout-item__packaging-copy">
                    {{seasonalBox.text}}
                </p>
            </div>

            <btn
                primary
                narrow
                :disabled="false"
                @click="addBoxToCart"
                class="cz2__stationary-text-transform"
            >
                {{ $t('ACTION_ADD_BOX') }}
            </btn>
        </div>
    </article>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__checkout-item__packaging {
            margin-bottom: 20px;
            box-shadow: 8px 8px black;
            padding: 8px;
            padding-left: 16px;

            background-color: white;
            color: black;

            display: flex;
            gap: 16px;

            .cz2__checkout-item__packaging-image {
                width: 90px;

                background-size: contain;
                background-position: center;
                background-repeat: no-repeat;
            }

            .cz2__checkout-item__packaging-content {
                flex: 1 1 0%;
            }

            .cz2__checkout-item__packaging-copy {
                margin: 4px 0 8px 0;

                @include font(h3-secondary);
                text-transform: none;
            }
        }
    }

    #cz2.cz2.cz2__is-kiosk {
        .cz2__checkout-item__packaging {
            padding: 22px 32px;
        }

        .cz2__checkout-item__packaging-content {
            display: flex;

            align-items: center;
            gap: 40px;

            button.cz2__btn {
                // Everywhere else buttons are 64px on kiosk...
                height: 40px;
                width: 180px;

                font-size: 15px;

                &:hover {
                    font-size: 17px;

                    box-shadow: 0px 4px 2px 1px rgba(0, 0, 0, 0.2);
                }
            }
        }

        .cz2__checkout-item__packaging-content__text {
            flex: 1 1 0;
        }
    }
</style>

<script>
    import Btn from './ui/Btn.vue';

    export default {
        components: {
            Btn,
        },

        computed: {
            seasonalBox() {
                return this.$store.getters.seasonalBox;
            },

            imageLink() {
                const l = this.seasonalBox?.image;

                if (l == null) {
                    return l;
                }

                if (l.startsWith('//')) {
                    return `https:${l}`;
                }

                return l;
            },
        },

        methods: {
            addBoxToCart() {
                this.$store.dispatch('addSeasonalBox');
            },
        },
    };
</script>
